import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./admin.css";

export default function FMSLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      setError("Email and password are required");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("adminRole", data.role);
        if (data.tower) localStorage.setItem("adminTower", data.tower);

        if (data.role === "fms") {
          window.location.href = "/fms/dashboard";
        } else {
          setError("This login is for FMS staff only. Use the Admin Login page instead.");
        }
      } else {
        setError(data.message || "Invalid credentials");
      }
    } catch (err) {
      setError("Server error. Try again later.");
    }

    setLoading(false);
  };

  return (
    <div className="admin-login-container">
      <h1>FMS Login</h1>

      <form onSubmit={handleLogin} className="admin-login-form">
        <input
          type="email"
          placeholder="FMS Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p className="admin-error">{error}</p>}

        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>

      <p className="tower-admin-link">
        New to the FMS team? <Link to="/fms/register">Register as FMS Staff</Link>
      </p>

      <p className="tower-admin-link">
        <Link to="/">← Back to Crown Residences</Link>
      </p>
    </div>
  );
}